import { Preferences } from '@capacitor/preferences';
import { setBootstrapCountry } from '@raptor-fe/core';
import { StorageKeys } from './storage.service';

/**
 * Reads the persisted country claim synchronously for bootstrap provider factories.
 * Checks sessionStorage before localStorage so it resolves correctly in both standard
 * and web-view storage modes.
 */
export function getPersistedCountrySync(): string | null {
    return sessionStorage.getItem(StorageKeys.COUNTRY_CODE) ?? localStorage.getItem(StorageKeys.COUNTRY_CODE);
}

/** Pre-reads the persisted country into the bootstrap holder before mobile app bootstrap. */
export async function loadBootstrapCountry(): Promise<void> {
    try {
        const { value } = await Preferences.get({ key: StorageKeys.COUNTRY_CODE });
        setBootstrapCountry(value);
    } catch {
        setBootstrapCountry(null);
    }
}
